module.exports = __webpack_public_path__ + "static/img/2.00fc70c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/2.png
// module id = BKa1
// module chunks = 0